import { AppAreaConfig } from '@/funnels/@types'

const appAreaConfig: AppAreaConfig = {
	appArea: 'male-water-fasting',
	landing: {
		ids: ['loader-water-balance-m'],
		route: {
			path: '/water-fasting-m',
			name: 'male-water-fasting-funnel',
		},
	},
	funnel: {
		id: 'ob-water-fasting-male',
		route: {
			path: '/water-fasting-m/ob/:page(.*)?',
			name: 'male-water-fasting',
		},
		slug: 'male-water-fasting',
		locale: ['en'],
	},
	prePaywall: {},
	paywall: {
		routeName: 'plan-m',
	},
	upsell: {
		routeNames: ['upsell-static-subscription-activated', 'upsell-m'],
	},
}

export default appAreaConfig
